import http from '../../http-common'

class SettingsDataService {
  create(data: any): Promise<any> {
    return http.post('/integrations/', data)
  }

  whatsappSignup(data: any): Promise<any> {
    try {
      console.log('[INFO] Enviando POST /integrations/whatsappSignup/')
    } catch (e) {}

    return http
      .post('/integrations/whatsappSignup/', data)
      .then((resp) => {
        try {
          console.log('[INFO] POST /integrations/whatsappSignup/ concluído', {
            status: resp?.status,
          })
        } catch (e) {}
        return resp
      })
      .catch((err) => {
        try {
          const status = err?.response?.status
          console.warn('[WARN] POST /integrations/whatsappSignup/ falhou', {
            status: typeof status === 'number' ? status : undefined,
          })
        } catch (e) {}
        throw err
      })
  }

  instagramSignup(data: any): Promise<any> {
    return http.post('/integrations/instagramSignup/', data)
  }

  revokeCredentials(data: any): Promise<any> {
    return http.post('/integrations/revokeCredentials/', data)
  }

  getSettings(): Promise<any> {
    return http.get('/integrations/')
  }

  upsertWhatsappIntegration(data: any): Promise<any> {
    return http.post('/integrations/upsertWhatsappIntegration/', data)
  }

  // Coexistence: status da sincronização por phone_number_id
  checkCoexistenceStatus(phoneNumberId: string): Promise<any> {
    return http.get(`/integrations/coexistence-status/${phoneNumberId}/`)
  }

  // Coexistence: iniciar sincronização manual (contacts | history)
  initiateCoexistenceSync(phoneNumberId: string, syncType: 'contacts' | 'history'): Promise<any> {
    return http.post('/integrations/initiate-coexistence-sync/', {
      phone_number_id: phoneNumberId,
      sync_type: syncType,
    })
  }

  // Coexistence (by phone): status da sincronização por telefone (sem expor PNID)
  checkCoexistenceStatusByPhone(phone: string): Promise<any> {
    // Expect phone normalized or raw; backend normaliza
    return http.get(`/integrations/coexistence-status-by-phone/${encodeURIComponent(phone)}/`)
  }

  // Coexistence (by phone): iniciar sincronização manual (contacts | history)
  initiateCoexistenceSyncByPhone(phone: string, syncType: 'contacts' | 'history'): Promise<any> {
    return http.post('/integrations/initiate-coexistence-sync-by-phone/', {
      phone,
      sync_type: syncType,
    })
  }
}

export default new SettingsDataService()
